import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { LayoutService } from './service/app.layout.service';
import { ConfigService } from 'app/app-config.service';
import { Select } from '@ngxs/store';
import { UserState } from '@state/user.state';
import { Observable } from 'rxjs';
import { UserClaims } from 'app/@types/dto/user-claims.model';

@Component({
    selector: 'app-sidebar',
    templateUrl: './app.sidebar.component.html',
})
export class AppSidebarComponent implements OnInit {
    timeout: any = null;

    @Select(UserState.getCurrentUserClaims) userClaims$: Observable<UserClaims | undefined>;

    logoImage: string;

    @ViewChild('menuContainer') menuContainer!: ElementRef;
    constructor(public layoutService: LayoutService, public el: ElementRef, public configService: ConfigService) {}

    private resetLogos() {
        this.logoImage = 'assets/images/logo/logo-h.webp';
    }

    private setLogos(newLogo: string) {
        this.logoImage = newLogo;
    }

    ngOnInit(): void {
        this.resetLogos();
        this.userClaims$.subscribe((uc) => {
            if (uc === undefined) return;
            if (uc.organization?.avatar === undefined) this.resetLogos();
            else this.setLogos(uc.organization.avatar);
        });
    }

    onMouseEnter() {
        if (!this.layoutService.state.anchored) {
            if (this.timeout) {
                clearTimeout(this.timeout);
                this.timeout = null;
            }
            this.layoutService.state.sidebarActive = true;
        }
    }

    onMouseLeave() {
        if (!this.layoutService.state.anchored) {
            if (!this.timeout) {
                this.timeout = setTimeout(() => (this.layoutService.state.sidebarActive = false), 300);
            }
        }
    }

    anchor() {
        this.layoutService.state.anchored = !this.layoutService.state.anchored;
    }
}
